export const payWithAmazonConfig = {
  button: { id: "pay-with-amazon", type: "large", color: "DarkGray" },
  wallet: { id: "wallet", width: 400, height: 260 },
  consent: { id: "consent", width: 400, height: 140 },
  production: false,
};
